import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { TandemLink } from 'library';

export default function ServicesMenu({
    isMenuOpen,
    handleMenuClose,
    anchorRef,
}: {
    isMenuOpen: boolean;
    handleMenuClose: () => void;
    anchorRef: React.RefObject<HTMLDivElement> | null;
}) {
    return (
        <Menu
            anchorEl={anchorRef?.current}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            sx={{
                borderRadius: 18,
            }}
        >
            <MenuItem>
                <TandemLink to="/daycare-staffing-locations" onClick={handleMenuClose}>
                    Locations
                </TandemLink>
            </MenuItem>
        </Menu>
    );
}
